export default function getArticleId(url) {
  const match = url.match(/(id=|-|\/)(\d{8})?(\d+)/);
  return match && Number(match[3]);
}
